import { call, put, select } from 'redux-saga/effects'
import { ApiResponse } from 'apisauce'

import api from 'src/services/api'

import { ApplicationState } from 'src/store'
import { ClientNotifyCatch } from 'src/config/bugsnag'

import { ResponseDataMyTeam } from './types'
import * as Actions from './actions'

export function* getMyTeam({
  payload: { options }
}: ReturnType<typeof Actions.getMyTeam>) {
  try {
    const {
      me: { organization }
    } = yield select((state: ApplicationState) => state)

    const { data, ok }: ApiResponse<ResponseDataMyTeam> = yield call(
      api.get,
      `organizations/${organization.organization_id}/request_itineraries/checkins?started_on=${options.filters.started_on}&ended_on=${options.filters.ended_on}`
    )

    if (ok) {
      yield put(Actions.getMyTeamSuccess(data.request_itinerary || []))
      return
    }

    yield put(Actions.getMyTeamFailure())
  } catch (err) {
    ClientNotifyCatch('Saga getMyTeam', err)
    yield put(Actions.getMyTeamFailure())
  }
}
